import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from '../../generic-components/Icon';
import Spinner, { SpinnerColor } from '../../generic-components/Spinner';
import DownArrow from '../../assets/svg/Down-arrow.svg';
import DownArrowActionAHigh from '../../assets/svg/Down-arrow-actionAHigh.svg';
import { ISidebarLink } from '../../types';

// import Button from '../../generic-components/Button';

interface IProps {
  menuItem: ISidebarLink;
  isMenuOpen: boolean;
  onDropdownClick: (link: ISidebarLink) => void;
  selectedSubLinkId: string;
  selectedLinkId: string;
  expandedSubMenuLinkId: string;
  isNew?: boolean;
}

const ACTION_CONTAINER = 'bg-[#EEF2FF] rounded-md';
const ACTIVE_LINK = 'flex items-center py-3 h-8 cursor-pointer text-bw08 font-metricRMedium ';
const INACTIVE_LINK = 'flex items-center py-3 h-8 cursor-pointer text-bw08';
const SideBarItem = ({
  menuItem,
  isMenuOpen,
  isNew,
  selectedLinkId,
  selectedSubLinkId,
  expandedSubMenuLinkId,
  onDropdownClick,
}: IProps) => {
  const { linkName, icon, iconSelected, subLinks } = menuItem;
  const [isSpinnerActive, setIsSpinnerActive] = useState<boolean>(false);
  const navigate = useNavigate();
  const isSomeSublinkAvailable = useMemo(() => menuItem.subLinks?.some((i) => !i.shouldHide), [menuItem]);
  const showSublinksMenu = useMemo(
    () => subLinks && isSomeSublinkAvailable && expandedSubMenuLinkId === menuItem.id && isMenuOpen,
    [menuItem],
  );

  const handleMenuItemClickClick = () => {
    if (menuItem.callback) menuItem.callback();
    if (!subLinks || !isSomeSublinkAvailable) {
      navigate(menuItem.path);
    } else {
      onDropdownClick(menuItem);
    }
  };
  return (
    <li>
      <div
        className={`px-[16px] flex justify-center items-center content-center cursor-pointer  whitespace-nowrap relative  mx-[8px] py-[4px] ${selectedLinkId === menuItem.id ? ACTION_CONTAINER : ''}`}
        role='presentation'
        onClick={handleMenuItemClickClick}
        id={menuItem.linkName.replaceAll(' ', '_')}
      >
        {isNew && isMenuOpen && (
          <div className='text-bw00 bg-action03 font-sourceSansPro text-[12px] fadeIn py-[2px] px-[6px] rounded-[4px] absolute right-0 top-[50%] translate-y-[-50%] translate-x-[-10px]'>
            New
          </div>
        )}
        <div
          className={`px-[0px] text-[14px] hover:text-action03 ${subLinks && menuItem.subLinkDropdownIds?.includes(selectedLinkId) ? ACTIVE_LINK : selectedLinkId === menuItem.id ? ACTIVE_LINK : INACTIVE_LINK} w-full`}
        >
          {icon && iconSelected && (
            <Icon
              iconId={`menuItem-${menuItem.linkName.replaceAll(' ', '_')}`}
              src={
                subLinks && menuItem.subLinkDropdownIds?.includes(selectedLinkId)
                  ? iconSelected
                  : selectedLinkId === menuItem.id
                    ? iconSelected
                    : icon
              }
              className={`w-[32px] h-[32px] aspect-square ${menuItem.subLinkDropdownIds?.includes(selectedLinkId) || selectedLinkId === menuItem.id ? 'text-action03' : 'text-bw07'}`}
            />
          )}
          {isMenuOpen && <div className='ml-[4px] w-full text-left relative'>{linkName}</div>}
        </div>
        <button
          id={`toggleSubMenuOpen_${menuItem.linkName.replaceAll(' ', '_')}`}
          className='cursor-pointer '
          tabIndex={0}
          type='button'
          onClick={handleMenuItemClickClick}
        >
          {isMenuOpen && subLinks && isSomeSublinkAvailable && (
            <Icon
              className={`duration-200 ${menuItem.id === expandedSubMenuLinkId ? 'text-action03' : 'text-bw07'}`}
              src={
                menuItem.subLinkDropdownIds?.includes(selectedLinkId) || selectedLinkId === menuItem.id
                  ? DownArrowActionAHigh
                  : DownArrow
              }
              rotated={expandedSubMenuLinkId === menuItem.id}
            />
          )}
        </button>
      </div>
      <div className={`flex w-[170px] mr-[10px] duration-500 transition-all overflow-hidden ${showSublinksMenu ? 'max-h-[500px] opacity-100 my-4 ml-[48px]' : 'max-h-[0px] opacity-0'}`}>
        <div className='flex flex-col gap-6 pl-[14px] w-full'>
          {subLinks?.map(
            (link) =>
              !link.shouldHide && (
                <div
                  key={link.id}
                  role='presentation'
                  className={`${link.shouldHide ? 'hidden' : ''} flex items-center ${link.callback ? 'hover:cursor-pointer' : ''}`}
                >
                  <button
                    disabled={link.disabled}
                    title={link.name}
                    id={`${linkName.replaceAll(' ', '_').toLowerCase()}_${link.id}`}
                    type='button'
                    onClick={async () => {
                      if (link?.analyticsCb) {
                        link.analyticsCb();
                      }
                      if (link.callback) {
                        setIsSpinnerActive(true);
                        await link.callback();
                        setIsSpinnerActive(false);
                      } else {
                        navigate(link.path);
                      }
                    }}
                  >
                    {isSpinnerActive && link.callback !== undefined ? (
                      <Spinner width='2rem' height='2rem' spinnerColor={SpinnerColor.Blue} />
                    ) : (
                      <p
                        className={`text-[14px] w-full ${link.callback ? 'text-bw07 mx-[auto] ' : 'text-bw07 '} ${isMenuOpen ? '' : 'hidden'} duration-100 flex items-centercursor-pointer text-left hover:text-action03 p-0 m-0 ${selectedSubLinkId === link.id ? 'text-action03 font-metricRMedium' : 'text-bw07'}`}
                      >
                        {link.name}
                      </p>
                    )}
                  </button>
                </div>
              ),
          )}
        </div>
      </div>
    </li>
  );
};

export default SideBarItem;
